import { render, staticRenderFns } from "./LoadingButton.vue?vue&type=template&id=1f59a0cd"
import script from "./LoadingButton.vue?vue&type=script&lang=js"
export * from "./LoadingButton.vue?vue&type=script&lang=js"
import style0 from "./LoadingButton.vue?vue&type=style&index=0&id=1f59a0cd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports